import { Component, Input, OnInit } from "@angular/core";
import { Link } from "./link.model";

@Component({
  selector: "ui-link",
  styleUrls: ["./link.component.scss"],
  templateUrl: "./link.component.html",
})
export class UiLinkComponent implements OnInit {

  @Input() private link: Link;
  @Input() private className: string;
  @Input() private disableDefaultStyling: boolean;
  private classes: string;

  public ngOnInit() {
    const baseClass = this.disableDefaultStyling ? "" : "link";
    this.classes = `${baseClass} ${this.className}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/ui-library/link/link.component.ts